import { useEffect } from 'react';
import { darkModeMediaQuery } from '#features/theme/darkModeMediaQuery';

export const useUpdateAppIcon = () => {
  useEffect(() => {
    const updateAppIcon = (event: Pick<MediaQueryList, 'matches'>) => {
      const newIcon = event.matches ? '/logo-dark.png' : '/logo-light.png';
      document.head
        .querySelector('link[rel="icon"]')
        ?.setAttribute('href', newIcon);
    };

    darkModeMediaQuery.addEventListener('change', updateAppIcon);

    updateAppIcon(darkModeMediaQuery);

    return () => {
      darkModeMediaQuery.removeEventListener('change', updateAppIcon);
    };
  }, []);
};
